// --------------------------------------------------------------
// Created On: 2025-04-17
// Author: Dimitra Weinstein
//
// Last Modified: 2025-05-28
// Modified By: Dimitra Weinstein
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./HelpImportCsv.module.scss";

// Explains how to import a CSV file for the Quick Order form.
export default function HelpImportCsv(): Component {
  return (
    <div>
      <p className="px-3 my-2">
        See the image below. When choosing to import a CSV file, the following headers are required: <br></br>
      </p>
      <ul className={styles.ul}>
        <li>part_number</li>
        <li>quantity</li>
        <li>impeller_trim_inches</li>
        <li>impeller_angle_degrees</li>
        <li>paint_color</li>
        <li>notes</li>
      </ul>
      <p className="px-3 my-2">
        <strong>Please be sure to use the exact header names, in the order as shown above.</strong> <br></br>
      </p>
      <p className="px-3 my-2">
        Once you have defined your column headers, fill in the details for each part you wish to order. <br></br>
        If you do not wish to specify a value for a column, (i.e., impeller_trim_inches, impeller_angle_degrees, or
        paint_color) you may leave it blank. <br></br>
      </p>
      <p className="px-3 my-2">
        The <strong>notes</strong> column is for your own record keeping. You can leave it blank, any information you
        include here will not be included with your order. <br></br>
      </p>
      <p className="px-3 my-2">
        You will have an opportunity to update part information once the file has been uploaded. <br></br>
      </p>
      <p className="px-3 my-2">
        <strong>Note:</strong> The CSV file must be saved in the <strong>.csv</strong> format. <br></br>
      </p>
      <img className="img-fluid col-11 mx-3 mt-3 mb-2" src="/images/eCommerce_QuickOrder_CSV_Example.png"></img>
    </div>
  );
}
